import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-block-title-icon",
  "use": "icon-block-title-icon-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-block-title-icon\">\n<style type=\"text/css\">\n\t#icon-block-title-icon .st0{fill:#1C7DC2;}\n\t#icon-block-title-icon .st1{fill:#FFFFFF;}\n</style>\n<path class=\"st0\" d=\"M10.4,12H1.6C0.7,12,0,11.3,0,10.4V1.6C0,0.7,0.7,0,1.6,0h8.7C11.3,0,12,0.7,12,1.6v8.7\n\tC12,11.3,11.3,12,10.4,12z\" />\n<polygon class=\"st1\" points=\"8.7,6 4.2,3.4 4.2,8.6 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol